var map = {
	"./activedirectory.svg": "6d4b",
	"./adfs.svg": "5a61",
	"./azuread.svg": "aa16",
	"./custom.svg": "8342",
	"./email.svg": "90a7",
	"./freeipa.svg": "8909",
	"./github.svg": "0116",
	"./googleoauth.svg": "b058",
	"./grafana.svg": "5d49",
	"./jaeger.svg": "e1e8",
	"./keycloak.svg": "1e67",
	"./kiali.svg": "a27a",
	"./linux.svg": "a5e7",
	"./longhorn.svg": "f2ad",
	"./neuvector.svg": "cb03f",
	"./okta.svg": "a9d2",
	"./openldap.svg": "6085",
	"./pagerduty.svg": "77a3",
	"./ping.svg": "fca3",
	"./prometheus.svg": "d703",
	"./shibboleth.svg": "9423",
	"./slack.svg": "e805",
	"./webhook.svg": "bb24",
	"./windows.svg": "1072"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ff88";